module.exports = __webpack_public_path__ + "img/realmoneylending-white-text-only-powered.bf0ec900.png";